module.exports = __webpack_public_path__ + "static/media/ravadhokla.2a1fb954.jpg";